import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const { token } = useSelector((state) => state.auth);
  const user = useSelector((state) => state.profile.user);
  const location = useLocation();
  if(token && user){
    return children
  }
  return <Navigate to="/login" replace />;
};

export default PrivateRoute;
